import Car from './car'

export default class Car30 extends Car {
  calculateAmount() {
    return 0.3 * this.fields.distance.value
  }
}
